import posthog, { PostHog } from 'posthog-js'

const PostHogTracker = {
	init (userId) {
		posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
            api_host: process.env.VUE_APP_POSTHOG_HOST,
            autocapture: true,
            capture_pageview: false,
            debug: process.env.VUE_APP_POSTHOG_DEBUG == 'true',
            loaded: (posthog: PostHog) => {
                posthog.identify(userId);
            },
        })
	},

	capture (event, payload) {
		posthog.capture(event, payload)
	}	
}
export default PostHogTracker